import TextfieldV2, {
  type TextfieldProps as TextfieldV2Props,
} from '@natera/material/lib/textfield/v2'
import { NumericFormat } from 'react-number-format'
import { cn } from '~/shared/lib/cn'
import { centsToDollars, dollarsToCents } from '~/shared/lib/currency'
import './textfield.scss'

interface TextfieldProps extends TextfieldV2Props {
  help?: boolean
  isHelperTextHighlighted?: boolean
  currency?: boolean
  onCentsChange?: (cents: number | null) => void
}

export function Textfield({
  className,
  outline = true,
  dense = true,
  fullWidth = true,
  help = false,
  readOnly = false,
  disabled = false,
  isHelperTextHighlighted = false,
  currency = false,
  ...rest
}: TextfieldProps) {
  const textfieldClassName = cn(
    'c-textfield',
    {
      'c-textfield--dense': dense,
      'c-textfield--help': help,
      'c-textfield--read-only': readOnly,
      'c-textfield--currency': currency,
      'c-textfield--helper-text-highlighted': isHelperTextHighlighted,
    },
    className,
  )

  const materialLeadIcon = currency
    ? 'attach_money'
    : help
      ? {
          children: 'help',
          fill: true,
        }
      : undefined

  if (currency) {
    const { value, defaultValue, type, onCentsChange, ...currencyRest } = rest

    return (
      <NumericFormat
        customInput={TextfieldV2}
        thousandSeparator
        decimalScale={2}
        fixedDecimalScale
        allowNegative
        allowedDecimalSeparators={[',', '.']}
        className={textfieldClassName}
        outline={outline}
        dense={dense}
        fullWidth={fullWidth}
        materialDropdownIcon="arrow_drop_down"
        materialLeadIcon={materialLeadIcon}
        disabled={disabled || readOnly}
        value={centsToDollars(value as number | null | undefined) ?? ''}
        defaultValue={defaultValue as string | number | undefined}
        onValueChange={(values) => onCentsChange?.(dollarsToCents(values.floatValue ?? null))}
        {...currencyRest}
      />
    )
  }

  return (
    <TextfieldV2
      className={textfieldClassName}
      outline={outline}
      dense={dense}
      fullWidth={fullWidth}
      materialDropdownIcon="arrow_drop_down"
      materialLeadIcon={materialLeadIcon}
      disabled={disabled || readOnly}
      {...rest}
    />
  )
}
